// JWT segments are base64url-encoded (RFC 7515): '-'/'_' instead of '+'/'/'
// and no '=' padding. atob() only accepts standard base64, so we normalise
// first — otherwise any payload whose encoding contains '-' or '_' (e.g. a long
// avatar_url claim) throws InvalidCharacterError. We also UTF-8 decode so
// non-ASCII claim values (names, etc.) round-trip correctly.
function decodeJwtSegment(segment: string): string {
  let b64 = segment.replace(/-/g, '+').replace(/_/g, '/');
  const pad = b64.length % 4;
  if (pad) b64 += '='.repeat(4 - pad);
  const binary = atob(b64);
  try {
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch {
    return binary;
  }
}

export function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(decodeJwtSegment(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}

export function parseJwtPayload(token: string) {
  try {
    return JSON.parse(decodeJwtSegment(token.split('.')[1]));
  } catch {
    return null;
  }
}
